<template>
<section class="navsection">
 <div style="background-color: #003;">
  <div style="background-color: #003;">
    <nav class="navbar navbar-expand-md navbar-dark bg-darkblue mb-4 fixed-top ">
      <router-link to="/" class="navbar-brand"><img class="imglogo" src="@/assets/relibridge.jpg" /></router-link>

      <ul class="rightbarlink rightbarlink1">
        <li><font-awesome-icon icon="fa-solid fa-bars"  class="btn btn-primary offcanvabtn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"/></li>
        <li>
          <router-link to="/" class="navbar-brand"> 
            <a class="langen formatlang" @click.prevent="setLangEn()" id="langen" :class="[getlang==='en' ? 'setEnLang' : '']">EN</a> | 
            <span class="langfr formatlang" @click.prevent="setLangFr()" id="langfr" :class="[getlang==='fr' ? 'setFrLang' : '']">FR</span>
          </router-link>
        </li>
        <li><span> <i class="fa-solid fa-magnifying-glass" data-bs-toggle="modal" data-bs-target="#staticBackdrop1"></i></span></li>
      </ul> 

        <ul class="navbar-nav ms-auto mb-2 mb-md-0 justify-content-end">
        <li class="nav-item dropdown has-megamenu"  v-for="(menu, index) in mainmenu" :key="menu.mid">
          <!-- <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" :id="`${menu.mid}`" @mouseover="getId(this)">{{ menu.mdesc }}</a> -->
          <a  class="nav-link " data-bs-toggle="dropdown" :class="[menu.mid===gml1 ? 'menulevel1' : '']" :id="`${menu.mid}`" @mouseover="getId($event, $event.target.value=menu.mid)" @click="selectItem($event, $event.target.value=menu.mid)">{{ menu.mdesc }}</a>
          <div class="dropdown-menu megamenu" role="menu">
            <div class="row g-3">
              <div class="col-lg-3 col-3">
                <div class="col-megamenu" v-for="(md, index2) in menualldesc" :key="index2.mfid_id">
                  <h1 class="captiontitle" v-if="index2 === index">{{ md.msdesc }}</h1>
                  <i class="captiondesc" v-if="index2 === index"><span v-html="md.fsecdesc"></span></i>
                </div>  <!-- col-megamenu.// -->
              </div><!-- end col-3 -->
              <div class="col-lg-3 col-3 vleftline">
                <div class="col-megamenu" >
                  <ul class="list-unstyled" v-for="secone in divsecone" :key="secone.did">
                    <li class="dospacing "><a href="#" :id="`${secone.pk}`" @mouseover="getsectwoId($event, $event.target.value=secone.did)" @click="goToOpenMenu($event, $event.target.value=secone.did)">{{ secone.fields['ds1desc']}}</a></li>
                    
                  </ul>
                </div>  <!-- col-megamenu.// -->
              </div><!-- end col-3 -->
              <div class="col-lg-3 col-3 vleftline">
                <div class="col-megamenu">
                  <ul class="list-unstyled" v-for="sectwo in divsectwo" :key="sectwo.did2">
                    <li class="dospacing"><a href="#" :id="`${sectwo.pk}`" @click="goToOpenMenuTwo(this)">{{ sectwo.fields['ds2desc']}}</a></li>
                  </ul>
                </div>  <!-- col-megamenu.// -->
              </div><!-- end col-3 -->
              <div class="col-lg-3 col-3 vleftline">
                <div class="col-megamenu" v-for="(md, index2) in menualldesc" :key="index2.mfid_id">
                  <!-- <h1 class="captiontitle" v-if="index2 === index">{{ md.msdesc }}</h1> -->
                  <i class="captiondesc widthreduce" v-if="index2 === index">
                    <div v-html="md.lscaption" class="paddingleft captiontitle"></div>
                    <div><img :src="`${md.lsimage}`" class="menuimages paddingleft"></div>
                    <div v-html="md.lsecdesc" class="paddingleft"></div>
                  </i>
                </div>  <!-- col-megamenu.// -->
              </div><!-- end col-3 -->
            </div><!-- end row --> 
          </div> <!-- dropdown-mega-menu.// -->
        </li>
        
      </ul>

     
      <ul class="rightbarlink righbarlink2">
        <li><font-awesome-icon icon="fa-solid fa-bars"  class="btn btn-primary offcanvabtn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions"/></li>
        <li>
          <router-link to="/" class="navbar-brand"> 
            <a class="langen formatlang" @click.prevent="setLangEn()" id="langen" :class="[getlang==='en' ? 'setEnLang' : '']">EN</a> | 
            <span class="langfr formatlang" @click.prevent="setLangFr()" id="langfr" :class="[getlang==='fr' ? 'setFrLang' : '']">FR</span>
          </router-link>
        </li>
        <li><span> <i class="fa-solid fa-magnifying-glass" data-bs-toggle="modal" data-bs-target="#staticBackdrop1"></i></span></li>
      </ul>
   
    </nav>
  </div>
  <div >

  </div> 
  <div class="breadcrum sticky breadcrumformat" style="padding-bottom: 30px;">
    <nav aria-label="breadcrumb" style='margin-top: 60px; '>
      <ol class="breadcrumb olformat"  style='margin-top: 30px; --bs-breadcrumb-divider: ">";'>
        <li class="breadcrumb-item" v-for="bcrumb in breadcrumbdata" style="padding-top: 14px; ">
          <a :href="`${bcrumb.bclink}`" class="breadcruma" :class="bcrumb.bcactive===true ? 'activelink' : 'nonactive'">{{ bcrumb.bcgname }}</a>
      </li>
      </ol>
    </nav>
  </div>
</div>   
  

      <div class="offcanvas offcanvas-start" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel">
            <router-link to="/" class="navbar-brand"><img class="imglogo" src="@/assets/relibridge.jpg" /></router-link>
          </h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item"  v-for="(menu, index) in mainmenu" :key="menu.mid">
              <h2 class="accordion-header" :id="`${menu.mid}`">
                <button class="accordion-button collapsed" :id="`${menu.mid}`" @mouseover="getId($event, $event.target.value=menu.mid)" type="button" data-bs-toggle="collapse" :data-bs-target="`#flush-collapse${menu.mid}`" aria-expanded="false" :aria-controls="`flush-collapse${menu.mid}`">
                  {{ $t(menu.mdesc) }}
                </button>
              </h2>
              <div :id="`flush-collapse${menu.mid}`" class="accordion-collapse collapse blockdisplay" :aria-labelledby="`${menu.mid}`" data-bs-parent="#accordionFlushExample">
                <div class="mobilemenusummary" v-for="(md, index2) in menualldesc" :key="index2.mfid_id">
                  <!-- <h1 class="indentcaption" v-if="index2 === index">{{ md.msdesc }}</h1> -->
                  <p  class="indenttextbody" v-if="index2 === index"><span v-html="md.fsecdesc"></span></p>
                </div>

                <div class="blockdisplay">
                  <ul class="list-unstyled" v-for="secone in divsecone" :key="secone.did">
                    <li class="dospacing1"><a class="indenttextlinks indenttextboldlinks" href="#" :id="`${secone.pk}`" @click="goToOpenMenu(this)"  @mouseover="getsectwoId(this)">{{ secone.fields['ds1desc']}}</a></li>
                    <div class="indentdiv" v-if="secone.fields['hasdropdown']">
                      <ul class="list-unstyled" v-for="sectwo in divsectwo" :key="sectwo.did2">
                        <li class="dospacing1" v-if="sectwo.fields['ds1fid'] === secone.pk"><a class="indenttextboldlinks indenttextotherlinks" href="#" @click="goToOpenMenuTwo(this)" :id="`${sectwo.pk}`">{{ $t(sectwo.fields['ds2desc'])}}</a></li>
                      </ul>
                    </div> 
                  </ul>
                </div>

                <div class="mobilemenusummary blockdisplay" v-for="(md, index2) in menualldesc" :key="index2.mfid_id">
                  <p  class="indenttextbody" v-if="index2 === index"><span v-html="md.lsecdesc"></span></p>
                </div>
              </div>
            </div>
            <!-- <div class="offcanvasfooter">
              <p>Footer</p>
            </div> -->
          </div>
        </div>
      </div>
  



<!-- Modal -->
<div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">Search Dialog</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
         
        <SearchAutocomplete
        @input="onChange($event)"
        :items="items"
        @goToLink="closeModalNow($event)"
      />
      </div>
   
    </div>
  </div>
</div>
</section>


</template>



<script>
// import { mapGetters } from 'vuex';

import axios from 'axios';
import SearchAutocomplete from '@/components/SearchAutocomplete.vue'
import {  useRouter } from "vue-router";
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';
import { useToast } from "vue-toastification";


export default {

  props: ['breadcrumbdata', 'breadcrumbtheme'],
  components: {
    SearchAutocomplete
  },
  // props: ['user'],
  data () {
    const lang = localStorage.getItem('lang')  || 'en';
    return {
      lang: lang,
      mainmenu: [],
      menualldesc: [],
      divsecone: [],
      divsectwo: [],
      getmenu: '',
      getmenutwo: '',
      id: 0,
      items: [],
      getlang: localStorage.getItem("lang"),
      gml1: parseInt(localStorage.getItem("al1active")),
    }
  },
  beforeCreate() {

},
  created() {
      window.addEventListener('popstate', this.popstateEventAction );
    },
  methods: {
    popstateEventAction() {
        // ... some action triggered when the back button is clicked
        this.removePopstateEventAction();
      },
      removePopstateEventAction() {
        window.removeEventListener('popstate', this.popstateEventAction);
      },

    selectItem($event){
      try {
        var ael1 = document.getElementById(id);
        let wkid = $event.target.value
        localStorage.setItem('al1active', $event.target.value)
        let getmenuid = localStorage.getItem('al1active')
        if (getmenuid === wkid) {
          ael1.classList.add("active")
        }
        
      }catch(error) {
        console.log(error)
      }
    },
    onChange($event) {
      let getVal = $event.target.value;
      axios.get(`getsearchdata/${getVal}`).then(
      response => {
        // this.filteredList = response.data
        this.items = response.data
      })
      .catch((error) => {
        console.log(error)
      })
    },

    closeModalNow($event){
      try {
        $('#staticBackdrop1').modal('hide');
    
      }catch(error) {
        console.log(error)
      }
    },

    setLangEn() {
      try {
        localStorage.setItem('lang', 'en');
        localStorage.setItem('langen', 'langen');
        this.$router.push('/')
        .then(() => {this.$router.go(0)})
      }catch(error) {
        this.$router.go();
      }
    },
    setLangFr() {
      try {
        localStorage.setItem('lang', 'fr');
        localStorage.setItem('langfr', 'langfr');
        this.$router.push('/')
        .then(() => {this.$router.go(0)})
      }catch(error) {
        this.$router.go();
      }
    },

    //1. from event get the id as an integer. 
    //2. get the element and pass the id to it. store the id in localStorage
    //3. add class but remove existing name class before adding the new class
    //4. finally, get data based on selected id.
    getId($event) {
      let id = parseInt($event.target.id);
      var ael = document.getElementById(id);
      localStorage.setItem('al1active', parseInt($event.target.value))
   
      let x = document.getElementsByClassName("menulevel1");
      if(x.length > 0) 
        { 
          x[0].classList.remove("menulevel1"); 
        }
        ael.classList.add("menulevel1")
   

      this.divsectwo = [];
      axios.get(`getdivsecone/${id}`).then(
      response => {
        this.divsecone = response.data.data
      })
      .catch((error) => {
        console.log(error)
      })
    },

    getsectwoId($event) {
      let id = parseInt($event.target.id);
      var ael1 = document.getElementById(id);
      localStorage.setItem('al2active', parseInt($event.target.value))
   
      let x1 = document.getElementsByClassName("menulevel2");
      if(x1.length > 0) 
        { 
          x1[0].classList.remove("menulevel2"); 
        }
        ael1.classList.add("menulevel2")



      axios.get(`getdivsectwo/${id}`).then(
      response => {
        this.divsectwo = response.data.data
        this.$router.push(`/${divsectwo}`)
        // console.log(response.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      // console.log(id);
    },

    async goToOpenMenu(id) {
      try{
        id = (event.target.id);
      await axios.get(`getds1link/${id}`).then(
      response => {
        var getmenu = response.data['ds1link']
        this.$router.push({name: `${getmenu}`})
        // console.log(response.data.data)
      })
      }catch(error) {
        console.log(error)
      }
    },
    async goToOpenMenuTwo(id){
      try{
        id = (event.target.id);
      await axios.get(`getds2link/${id}`).then(
      response => {
        var getmenutwo = response.data['ds2link']
        this.$router.push(`/${getmenutwo}`)
        this.$router.push({name:`${getmenutwo}`})
              // console.log(response.data.data)
      })
      }catch(error) {
        console.log(error)
      }
    },
 
  },

mounted() {
  let mycid = localStorage.getItem('al1active')
  let mylang = localStorage.getItem('lang')

  try {
    if(mycid != "") {
    let x1 = document.getElementsByClassName(mycid);
    x1.classList.add("menulevel1")
  }
  }catch(error){
    console.log(error)
  }
  axios.get('menualldesc/').then(
    response => {
      this.menualldesc = response.data
    })
    .catch((error) => {
      console.log(error)
    })

  axios.get('mainmenu/').then(
    response => {
      this.mainmenu = response.data
    })
    .catch((error) => {
      console.log(error)
    })
  }

}
</script>

<style lang="scss" scoped>
.accordion-button {
  background-image: url("../assets/slide-5.jpg");
  color: white; 
}
.breadcrumb { 
	--bs-breadcrumb-padding-x: 0; 
	--bs-breadcrumb-padding-y: 0; 
	--bs-breadcrumb-margin-bottom: 1rem; 
	--bs-breadcrumb-font-size: 0.85rem; 
	--bs-breadcrumb-bg: ; 
	--bs-breadcrumb-border-radius: ; 
	--bs-breadcrumb-divider-color: red; 
	--bs-breadcrumb-item-padding-x: 1.2rem; 
	--bs-breadcrumb-item-active-color: green; 
	display: flex; 
	flex-wrap: wrap; 
  border-top: solid thin red;
	padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x); 
	margin-bottom: var(--bs-breadcrumb-margin-bottom); 
	font-size: var(--bs-breadcrumb-font-size); 
	list-style: none; 
	background-color: var(--bs-breadcrumb-bg); 
	border-radius: var(--bs-breadcrumb-border-radius); 
} 

.breadcrumb-item+.breadcrumb-item::before { 
	float: left; 

	padding-right: var(--bs-breadcrumb-item-padding-x); 
	color: var(--bs-breadcrumb-divider-color); 
	content: var(--bs-breadcrumb-divider, "+") 
		/* rtl: var(--bs-breadcrumb-divider, "+") */
	; 
}

.fa-magnifying-glass {
  padding-left: 20px;
}
.paddingleft {
  padding-left: 20px;
  margin-bottom: 10px;
}
.offcanvasfooter {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 400px;
  height: 200px;
  color: white;
  text-align: center;
  z-index: -1000;
}
.menuimages {
  width: 90%;
  height: 200px;

}

.widthreduce {
  margin-right: 20px;
}
.offcanvas{
  display: block;
  width: 100%;
  height: 100%;
  background-image: url("../assets/slide-5.jpg"); 
  object-fit: cover;
  display: block;
 
}


.accordion-item{
  background-image: url("../assets/slide-5.jpg"); 
  color:white;
}
.offcanvas-body {
  opacity: .7;
  color: white;
}

.indentdiv {
  margin-left: 50px;
}

.indentcaption {
  text-align: center;
  color: white;
}

.indenttextbody {
  margin-left: 30px;
  margin-right: 10px;
  text-align: justify;
  color: white;
}

.indenttextlinks {
  margin-left: 18px;
  color: white;
}

/* Indentation level two after first link is clicked */
.indenttextotherlinks {
  color: white;
  margin-left: 32px;
}

/* Change color to orange on hover */
.indenttextboldlinks:hover {
  color: orange;
  font-weight: bold;
}

/* Accordion button to white */
.accordion-button {
  color: white;
}
.mobilemenusummary {
  color: #003;
  margin-top: 20px;
  color: black;
}

/* Logo with and position*/
.imglogo {
  width: 220px;
  height: 50px;
  margin-left: 60px;
  text-decoration: none;
}

.offcanvas-header {
  background-color: #003;

.blockdisplay {
  margin-left: 10px;
}
.btn-close {
  background-color: white;
}

}
.g-3 {
  padding-top: 30px;
}

.dropdown-toggle {
  margin-right: 40px;
}
.dropdow-toggle button {
  display: none;
}
.dospacing {
  padding-top: 15px;
  margin-left: 15px;
}

.dospacing1 {
  padding-top: 15px;
  margin-left: 35px;
  color: white;
}
.btn {
 background-color: #1e1e2d;
 border-color: #1e1e2d;
}
.btn:hover {
  color:  #1e1e2d;
}

.navbar .megamenu{ padding: 1rem;}
.navbar-nav {
  height: auto;
}

.captiontitle {
  color: white;
  font-size: 24px;
  font-weight: bold;
}

.captiondesc {
  color: white;
  font-size: 16px;
}
.vleftline {
  border-left: solid thin white; 
}
.navbar {
background-color: #003;
}

.megamenu {
background-color: #003; 

}
.g-3{
  margin-left: 100px;
  margin-right: 100px;
  padding-bottom: 20px;
  color: white;
}

.flexboxes {
  display: none;
}

.mainselect {
  margin-right: 40px;
  background-color: #003;
  color: white;
  border: solid #003 thin;
}

.navsection {
  background-color: #003;
}


.dropdown:hover>.dropdown-menu {
  display: block;
}

.dropdown>.dropdown-toggle:active {
  /*Without this, clicking will make it sticky*/
    pointer-events: none;
}
.activelink {
  cursor: none;
  color: orangered;
}
.nonactive {
  color: white;
}

.olformat {
  margin-top: 50px;
  padding-left: 100px;
  padding-right: 100px;
}
.MuiBreadcrumbs-separator{
  color: red;
  font-size: 25px;
  position: relative;
  top: -2px;
}
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.fa-magnifying-glass {
  padding-right: 30px;
  margin-left: -20px;
  margin-top: 7px;
  color: white;
  font-size: 20px;
  cursor: pointer;
}
.modal-header {
  background-color: #003;
  color: white;
}

.btn-close {
  background-color: white;
}
.searchbox {
  padding-top: 40px;
  padding-bottom: 40px;
}
.modal-dialog {
  height: auto;
}
.active {
  border-top: thin solid orangered;
}

.setEnLang {
  color: red;
}
.setFrLang {
  color: red;
}
.menulevel1 {
 color: red;
 border-top: solid thin red;
 border-bottom: solid thin white;
}
@media (min-width: 300px) and (max-width: 550px) {
  .imglogo{
    width: 60%;
  }
.rightbarlink {
  display: flex;
  margin-top: -40px;
  margin-left: 160px;
  text-decoration: none;
}
.rightbarlink li {
  list-style-type: none;
}
.langen {
  margin-left: 10px;
}
.rightbarlink1 {
  visibility: hidden;
}
}


/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .navbar .has-megamenu{
    position:static!important;}
  .navbar .megamenu{
    left:0; 
    right:0; 
    width:100%; 
    margin-top:0;  
  }
  .navbar {
    height: 80px;
    background-color: #003;
  }
  .imglogo, a:active {
    margin-left: 10px; 
    text-decoration: none;
  }


  .navbar {
    background-color: #003;
    
  }
  .navbar-nav {
    display: none;
  }
  .fa-bars {
    display: flex;
  }

  .breadcrumsection {
    margin-top: 110px;
  }
  .mainselect {
    display: none;
  }

  .flexboxes {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: 30px;
  }

  .mainselect1 {
    background-color: #003;
    color: white;
    border: solid #003 thin;
    margin-right: 20px;
  }
  .breadcrumformat {
    height: 200px;
  }
  .autocomplete {
    position: relative;
  }

  .autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 120px;
    min-height: 1em;
    max-height: 6em;    
    overflow: auto;
  }

  .autocomplete-result {
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result:hover {
    background-color: #4AAE9B;
    color: white;
  }
  .imglogo{
    width: 60%;
  }
.rightbarlink {
  display: flex;
  margin-top: -40px;
  margin-left: 260px;
  text-decoration: none;
}
.rightbarlink li {
  list-style-type: none;
}
.langen {
  margin-left: 10px;
}
.rightbarlink2 {
  visibility: hidden;
}
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .navbar .has-megamenu{
    position:static!important;}
  .navbar .megamenu{
    left:0; 
    right:0; 
    width:100%; 
    margin-top:0;  
  }
  .navbar {
    height: 80px;
    background-color: #003;
  }
  .imglogo, a:active {
    margin-left: 30px; 
    text-decoration: none;
  }

  .navbar {
    background-color: #003;
    
  }
  .navbar-nav {
    display: none;
  }
  .fa-bars {
    display: flex;
  }

  .breadcrumsection {
    margin-top: 110px;
  }
  .mainselect {
    display: none;
  }

  .flexboxes {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: 30px;
  }

  .mainselect1 {
    background-color: #003;
    color: white;
    border: solid #003 thin;
    margin-right: 20px;
  }
.imglogo{
    width: 200px;
 
  }
.rightbarlink {
  display: flex;
  margin-left: -200px;
  text-decoration: none;
  z-index: -1000;
  
}
.rightbarlink li {
  list-style-type: none;
}
.langen {
  margin-left: 30px;
}
.langfr {
  margin-right: 20px;
}
.rightbarlink1 {
  visibility: hidden;
}
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  .navbar .has-megamenu{
    position:static!important;}
  .navbar .megamenu{
    left:0; 
    right:0; 
    width:100%; 
    margin-top:0;  
  }
  .navbar {
    height: 80px;
    background-color: #003;
  }
  .imglogo, a:active {
    margin-left: 30px; 
    text-decoration: none;
  }

  .navbar {
    background-color: #003;
    
  }
  .navbar-nav {
    display: none;
  }
  .fa-bars {
    display: flex;
  }

  .breadcrumsection {
    margin-top: 110px;
  }
 
 

  .mainselect1 {
    background-color: #003;
    color: white;
    border: solid #003 thin;
    margin-right: 20px;
  }
  .nav-link:hover {
    color: orangered;
    border-bottom: thin solid white;
  }

  .imglogo{
    width: 200px;
 
  }
.rightbarlink {
  display: flex;
  margin-left: 100px;
  text-decoration: none;
  z-index: -1000;
  margin-top: 30px;
  
}
.rightbarlink li {
  list-style-type: none;
}
.langen {
  margin-left: 30px;
}
.langfr {
  margin-right: 20px;
}
.rightbarlink1 {
  visibility: hidden;
}
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
 
  .rightbarlink {
    display: flex;
  
    margin-left: 190px;
    text-decoration: none;
  }
  .rightbarlink li {
    list-style-type: none;
  }
  .langen {
    margin-left: 10px;
  }
  .fa-magnifying-glass {
    margin-top: 5px;
  }
  .rightbarlink1 {
    visibility: hidden;
  }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .navbar .has-megamenu{
    position:static!important;}
  .navbar .megamenu{
    left:0; 
    right:0; 
    width:100%; 
    margin-top:0;  
  }
  .navbar {
    height: 80px;
    background-color: #003;
  }
  .navbar-nav {
    display: flex;
  }
  .fa-bars {
    display: none;
  }
  .rightbarlink1 {
    visibility: hidden;
    margin-left: -20px;
  }
 } 
</style>
